import { render, staticRenderFns } from "./AuthShell.vue?vue&type=template&id=0487d3b8"
import script from "./AuthShell.vue?vue&type=script&lang=js"
export * from "./AuthShell.vue?vue&type=script&lang=js"
import style0 from "./AuthShell.vue?vue&type=style&index=0&id=0487d3b8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports